import React from "react";
import AdditionalCompliances from "./AdditionalCompliances";

const CT_TYPES = ["Corporate Tax", "Corporate Tax Registration", "CT Deregistration"];

export default function CorporateTax() {
  return <AdditionalCompliances moduleTitle="Corporate Tax" moduleTypes={CT_TYPES} showDeadlineInsteadOfReportNumber={true} />;
}
